/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';
import {
    RegistrationOptionObjectType,
    RegistrationOptionObjectTypeFromJSON,
    RegistrationOptionObjectTypeFromJSONTyped,
    RegistrationOptionObjectTypeToJSON,
} from './RegistrationOptionObjectType';
import {
    RegistrationSaleStatus,
    RegistrationSaleStatusFromJSON,
    RegistrationSaleStatusFromJSONTyped,
    RegistrationSaleStatusToJSON,
} from './RegistrationSaleStatus';
import {
    Subtotal,
    SubtotalFromJSON,
    SubtotalFromJSONTyped,
    SubtotalToJSON,
} from './Subtotal';

/**
 * 
 * @export
 * @interface RegistrationOptionCreateParams
 */
export interface RegistrationOptionCreateParams {
    /**
     * 
     * @type {RegistrationOptionObjectType}
     * @memberof RegistrationOptionCreateParams
     */
    object: RegistrationOptionObjectType;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    description?: string;
    /**
     * 
     * @type {Subtotal}
     * @memberof RegistrationOptionCreateParams
     */
    cost?: Subtotal;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationOptionCreateParams
     */
    include_fee: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationOptionCreateParams
     */
    free: boolean;
    /**
     * 
     * @type {Gender}
     * @memberof RegistrationOptionCreateParams
     */
    gender?: Gender;
    /**
     * 
     * @type {number}
     * @memberof RegistrationOptionCreateParams
     */
    minimum_age?: number;
    /**
     * 
     * @type {number}
     * @memberof RegistrationOptionCreateParams
     */
    maximum_age?: number;
    /**
     * 
     * @type {number}
     * @memberof RegistrationOptionCreateParams
     */
    quantity_total: number;
    /**
     * Registrations that are pending, placed, or checked_in for an event.
     * @type {number}
     * @memberof RegistrationOptionCreateParams
     */
    quantity_sold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationOptionCreateParams
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    appointment_option_id?: string;
    /**
     * 
     * @type {RegistrationSaleStatus}
     * @memberof RegistrationOptionCreateParams
     */
    sale_status?: RegistrationSaleStatus;
    /**
     * 
     * @type {string}
     * @memberof RegistrationOptionCreateParams
     */
    event_id: string;
    /**
     * 
     * @type {Date}
     * @memberof RegistrationOptionCreateParams
     */
    sale_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RegistrationOptionCreateParams
     */
    sale_end?: Date;
}

export function RegistrationOptionCreateParamsFromJSON(json: any): RegistrationOptionCreateParams {
    return RegistrationOptionCreateParamsFromJSONTyped(json, false);
}

export function RegistrationOptionCreateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationOptionCreateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'object': RegistrationOptionObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'cost': !exists(json, 'cost') ? undefined : SubtotalFromJSON(json['cost']),
        'include_fee': json['include_fee'],
        'free': json['free'],
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'minimum_age': !exists(json, 'minimum_age') ? undefined : json['minimum_age'],
        'maximum_age': !exists(json, 'maximum_age') ? undefined : json['maximum_age'],
        'quantity_total': json['quantity_total'],
        'quantity_sold': !exists(json, 'quantity_sold') ? undefined : json['quantity_sold'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'appointment_option_id': !exists(json, 'appointment_option_id') ? undefined : json['appointment_option_id'],
        'sale_status': !exists(json, 'sale_status') ? undefined : RegistrationSaleStatusFromJSON(json['sale_status']),
        'event_id': json['event_id'],
        'sale_start': !exists(json, 'sale_start') ? undefined : (new Date(json['sale_start'])),
        'sale_end': !exists(json, 'sale_end') ? undefined : (new Date(json['sale_end'])),
    };
}

export function RegistrationOptionCreateParamsToJSON(value?: RegistrationOptionCreateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'object': RegistrationOptionObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'name': value.name,
        'description': value.description,
        'cost': SubtotalToJSON(value.cost),
        'include_fee': value.include_fee,
        'free': value.free,
        'gender': GenderToJSON(value.gender),
        'minimum_age': value.minimum_age,
        'maximum_age': value.maximum_age,
        'quantity_total': value.quantity_total,
        'quantity_sold': value.quantity_sold,
        'hidden': value.hidden,
        'timezone': value.timezone,
        'appointment_option_id': value.appointment_option_id,
        'sale_status': RegistrationSaleStatusToJSON(value.sale_status),
        'event_id': value.event_id,
        'sale_start': value.sale_start === undefined ? undefined : (value.sale_start.toISOString()),
        'sale_end': value.sale_end === undefined ? undefined : (value.sale_end.toISOString()),
    };
}

